import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RentOptionFormDrawerSchema, DrawerMode } from '../types';
import { RentOptionDocument } from 'entities/RentOption';

const initialState: RentOptionFormDrawerSchema = {
  rentOption: null,
  mode: null,
};

const rentOptionFormDrawerSlice = createSlice({
  name: 'rentOptionFormDrawer',
  initialState,
  reducers: {
    setOpenRentOptionForm: (
      state: RentOptionFormDrawerSchema,
      action: PayloadAction<{ mode: Nullable<DrawerMode>; rentOption?: Nullable<RentOptionDocument> }>,
    ) => {
      state.mode = action.payload.mode;
      state.rentOption = action.payload.rentOption;
    },
  },
});

export const { actions: rentOptionFormDrawerActions, reducer: rentOptionFormDrawerReducer } = rentOptionFormDrawerSlice;
